/*@ngInject*/
const DropdownButtonController = function ($rootScope, $scope, $element, coreConstant) {

    this.$onInit = function () {
        $element.addClass('umDropdownButton');
        this.enabled = this.enabled !== 'false' && this.enabled !== false;
        this.tooltipEnabled = this.tooltipEnabled !== 'false' && this.tooltipEnabled !== false;
        this.showBusinessCard = this.canShowBusinessCard();
    };

    this.$onChanges = function () {
        this.showBusinessCard = this.canShowBusinessCard();
    };

    this.canShowBusinessCard = function () {
        return (!_.isNil(this.businessCardUserId) || !_.isNil(this.businessCardOrganizationId)) && this.hasBusinessCard;
    };

    this.onBusinessCardDropdownClick = function (event) {
        if (this.enabled) {
            $rootScope.$broadcast(coreConstant.event.HIDE_BUSINESS_CARD_ON_DROPDOWN);
            this.onClick({event: event});
        }
    };

    this.onDropdownClick = function (event) {
        this.onClick({event: event});
    };

    this.onDropdownKeydown = function (event) {
        if (event.keyCode === 13 || event.keyCode === 32) { // Enter or space key only
            this.onClick({event: event});
            event.stopPropagation();
        }
    };
};

angular.module('umCore')
    .controller('umDropdownButtonController', DropdownButtonController);
